module.exports = __webpack_public_path__ + "static/img/Frame3465767.ae2cbc68.png";